import { Instagram, Mail, MessageCircle } from "lucide-react";
import { LogoFull } from "./Logo";
import { EMAIL, INSTAGRAM, NAV, waLink } from "./data";
import { scrollToId } from "./scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-selva pt-20 text-arena">
    <div aria-hidden="true" className="absolute inset-x-0 top-0 flex h-2"><span className="flex-1 bg-barro" /><span className="flex-1 bg-mar" /><span className="flex-1 bg-brasil" /><span className="flex-1 bg-sol" /></div>
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
      <div className="flex flex-col justify-between gap-10 md:flex-row">
        <div className="max-w-sm">
          <LogoFull className="h-36 w-36 p-1" />
          <p className="mt-5 text-arena/80">Planificación de viajes a Brasil, pensada para viajeros que quieren vivirlo de verdad.</p>
        </div>
        <nav className="grid grid-cols-2 gap-x-12 gap-y-3">
          {NAV.map((n) => (
            <button key={n.id} data-testid={`footer-link-${n.id}`} onClick={() => scrollToId(n.id)} className="text-left font-semibold text-arena/85 transition-colors hover:text-sol">{n.label}</button>
          ))}
        </nav>
        <div className="flex gap-3">
          <a data-testid="footer-whatsapp" aria-label="WhatsApp" href={waLink()} target="_blank" rel="noopener noreferrer" className="flex h-12 w-12 items-center justify-center rounded-full bg-sol text-selva transition-transform hover:-translate-y-1"><MessageCircle className="h-5 w-5" /></a>
          <a data-testid="footer-instagram" aria-label="Instagram" href={`https://instagram.com/${INSTAGRAM}`} target="_blank" rel="noopener noreferrer" className="flex h-12 w-12 items-center justify-center rounded-full border border-arena/30 transition-transform hover:-translate-y-1"><Instagram className="h-5 w-5" /></a>
          <a data-testid="footer-email" aria-label="Email" href={`mailto:${EMAIL}`} className="flex h-12 w-12 items-center justify-center rounded-full border border-arena/30 transition-transform hover:-translate-y-1"><Mail className="h-5 w-5" /></a>
        </div>
      </div>
    </div>
    <p aria-hidden="true" className="mt-16 select-none whitespace-nowrap pb-[0.12em] text-center font-display text-[17vw] font-extrabold leading-[0.9] tracking-[-0.05em] text-sol">
      Jaha Brasilpe
    </p>
    <div className="border-t border-arena/15 py-6 text-center text-sm text-arena/70">
      © {new Date().getFullYear()} Jaha Brasilpe · Aquí comienza tu viaje
    </div>
  </footer>
);
